// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFileTypeDto } from './IFileTypeDto';
import {
    IFileTypeDtoFromJSON,
    IFileTypeDtoFromJSONTyped,
    IFileTypeDtoToJSON,
    IFileTypeDtoToJSONTyped,
} from './IFileTypeDto';
import type { IFileActorDto } from './IFileActorDto';
import {
    IFileActorDtoFromJSON,
    IFileActorDtoFromJSONTyped,
    IFileActorDtoToJSON,
    IFileActorDtoToJSONTyped,
} from './IFileActorDto';

/**
 * 
 * @export
 * @interface IFileInfoDto
 */
export interface IFileInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IFileInfoDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IFileInfoDto
     */
    name?: string;
    /**
     * 
     * @type {Set<number>}
     * @memberof IFileInfoDto
     */
    partner_ids?: Set<number>;
    /**
     * 
     * @type {Set<number>}
     * @memberof IFileInfoDto
     */
    employer_ids?: Set<number>;
    /**
     * 
     * @type {IFileActorDto}
     * @memberof IFileInfoDto
     */
    uploaded_by?: IFileActorDto;
    /**
     * 
     * @type {string}
     * @memberof IFileInfoDto
     */
    upload_way?: IFileInfoDtoUploadWayEnum;
    /**
     * 
     * @type {string}
     * @memberof IFileInfoDto
     */
    file_path?: string;
    /**
     * 
     * @type {string}
     * @memberof IFileInfoDto
     */
    origin_file_path?: string;
    /**
     * 
     * @type {IFileTypeDto}
     * @memberof IFileInfoDto
     */
    file_types?: IFileTypeDto;
    /**
     * 
     * @type {Date}
     * @memberof IFileInfoDto
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IFileInfoDto
     */
    processed_at?: Date;
    /**
     * 
     * @type {number}
     * @memberof IFileInfoDto
     */
    records_errors?: number;
    /**
     * 
     * @type {IFileActorDto}
     * @memberof IFileInfoDto
     */
    processed_by?: IFileActorDto;
}

/**
* @export
* @enum {string}
*/
export enum IFileInfoDtoUploadWayEnum {
    FTP = 'FTP',
    UI = 'UI'
}


/**
 * Check if a given object implements the IFileInfoDto interface.
 */
export function instanceOfIFileInfoDto(value: object): value is IFileInfoDto {
    return true;
}

export function IFileInfoDtoFromJSON(json: any): IFileInfoDto {
    return IFileInfoDtoFromJSONTyped(json, false);
}

export function IFileInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFileInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'partner_ids': json['partner_ids'] == null ? undefined : new Set(json['partner_ids']),
        'employer_ids': json['employer_ids'] == null ? undefined : new Set(json['employer_ids']),
        'uploaded_by': json['uploaded_by'] == null ? undefined : IFileActorDtoFromJSON(json['uploaded_by']),
        'upload_way': json['upload_way'] == null ? undefined : json['upload_way'],
        'file_path': json['file_path'] == null ? undefined : json['file_path'],
        'origin_file_path': json['origin_file_path'] == null ? undefined : json['origin_file_path'],
        'file_types': json['file_types'] == null ? undefined : IFileTypeDtoFromJSON(json['file_types']),
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'processed_at': json['processed_at'] == null ? undefined : (new Date(json['processed_at'])),
        'records_errors': json['records_errors'] == null ? undefined : json['records_errors'],
        'processed_by': json['processed_by'] == null ? undefined : IFileActorDtoFromJSON(json['processed_by']),
    };
}

export function IFileInfoDtoToJSON(json: any): IFileInfoDto {
    return IFileInfoDtoToJSONTyped(json, false);
}

export function IFileInfoDtoToJSONTyped(value?: IFileInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'partner_ids': value['partner_ids'] == null ? undefined : Array.from(value['partner_ids'] as Set<any>),
        'employer_ids': value['employer_ids'] == null ? undefined : Array.from(value['employer_ids'] as Set<any>),
        'uploaded_by': IFileActorDtoToJSON(value['uploaded_by']),
        'upload_way': value['upload_way'],
        'file_path': value['file_path'],
        'origin_file_path': value['origin_file_path'],
        'file_types': IFileTypeDtoToJSON(value['file_types']),
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'processed_at': value['processed_at'] == null ? undefined : ((value['processed_at']).toISOString()),
        'records_errors': value['records_errors'],
        'processed_by': IFileActorDtoToJSON(value['processed_by']),
    };
}

